export default __webpack_public_path__ + "static/media/product_bg.7a7dcbe7.png";